import React, { useState } from "react";
import { UploadZone, DownloadButton, ResetButton, loadImage } from "./_shared";

export default function ImageResizer() {
  const [file, setFile] = useState(null);
  const [dims, setDims] = useState({ w: 0, h: 0, ow: 0, oh: 0 });
  const [lock, setLock] = useState(true);
  const [outUrl, setOutUrl] = useState(null);

  const handleFile = async (f) => {
    const { img } = await loadImage(f);
    setFile(f);
    setDims({ w: img.naturalWidth, h: img.naturalHeight, ow: img.naturalWidth, oh: img.naturalHeight });
    setOutUrl(URL.createObjectURL(f));
  };

  const setW = (w) => {
    const nw = Math.max(1, Number(w) || 1);
    const nh = lock ? Math.round((dims.oh / dims.ow) * nw) : dims.h;
    setDims((d) => ({ ...d, w: nw, h: nh }));
  };
  const setH = (h) => {
    const nh = Math.max(1, Number(h) || 1);
    const nw = lock ? Math.round((dims.ow / dims.oh) * nh) : dims.w;
    setDims((d) => ({ ...d, w: nw, h: nh }));
  };

  const process = async () => {
    const { img } = await loadImage(file);
    const canvas = document.createElement("canvas");
    canvas.width = dims.w; canvas.height = dims.h;
    canvas.getContext("2d").drawImage(img, 0, 0, dims.w, dims.h);
    canvas.toBlob((blob) => {
      if (outUrl) URL.revokeObjectURL(outUrl);
      setOutUrl(URL.createObjectURL(blob));
    }, file.type || "image/png", 0.95);
  };

  const reset = () => { setFile(null); setOutUrl(null); };

  if (!file) return <UploadZone onFile={handleFile} />;
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] p-4">
        <img src={outUrl} alt="preview" className="w-full max-h-96 object-contain" />
      </div>
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 p-6 bg-white dark:bg-[#121316] grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">Width (px)</label>
          <input type="number" value={dims.w} onChange={(e) => setW(e.target.value)} data-testid="resize-width" className="mt-1 w-full rounded-lg border border-slate-200 dark:border-white/10 bg-white dark:bg-[#1a1c20] px-3 py-2 text-slate-900 dark:text-white" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">Height (px)</label>
          <input type="number" value={dims.h} onChange={(e) => setH(e.target.value)} data-testid="resize-height" className="mt-1 w-full rounded-lg border border-slate-200 dark:border-white/10 bg-white dark:bg-[#1a1c20] px-3 py-2 text-slate-900 dark:text-white" />
        </div>
        <label className="flex items-center gap-2 md:mt-6 text-sm text-slate-700 dark:text-slate-200">
          <input type="checkbox" checked={lock} onChange={(e) => setLock(e.target.checked)} /> Lock aspect ratio
        </label>
      </div>
      <div className="flex items-center gap-3">
        <button onClick={process} data-testid="tool-process-button" className="px-5 py-2.5 rounded-full bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-sm font-medium hover:opacity-90 transition-opacity">Apply</button>
        <DownloadButton href={outUrl} filename={`resized-${file.name}`}>Download</DownloadButton>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
